import React, { useEffect } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import styled from '@emotion/styled'
import OrderAddress from 'modules/order/components/address/address'
import useOrder from 'modules/order/state/order/use-order'
import { FormAddressValue } from 'modules/order/state/address/address-types'
import { registerForm, unregisterForm } from '../../utils/single-step-form-orchestrator'

export type DonorInfoFormData = FormAddressValue

const DonorInfoContainer = styled.div`
  /* Remove top margin from the first label in the first input field */
  & > div > div:first-child > div:first-child label:first-child {
    margin-top: 0 !important;
  }
`

const DonorInfo = () => {
  const order = useOrder()

  // Prepare form address data to match the expected format
  const formAddress: FormAddressValue = {
    addressLine1: order.address.value.line1,
    addressLine2: order.address.value.line2,
    ...order.address.value,
  }

  const form = useForm<DonorInfoFormData>({
    values: {
      ...formAddress,
    },
    resolver: yupResolver(order.address.schema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  const {
    watch,
    formState: { errors },
  } = form

  // Watch country and state for address component
  const watchCountry = watch('country') || 'US'
  const watchState = watch('state') || ''

  // Register the form with the orchestrator
  useEffect(() => {
    registerForm({
      name: 'donorInfo',
      formRef: form,
      errorMessage: 'Please fill in all required donor information fields',
    })

    return () => unregisterForm({ name: 'donorInfo' })
  }, [form])

  return (
    <FormProvider {...form}>
      <DonorInfoContainer>
        {/* Address Fields */}
        <OrderAddress<DonorInfoFormData>
          errors={errors}
          watchCountry={watchCountry.toUpperCase()}
          watchState={watchState.toUpperCase()}
        />
      </DonorInfoContainer>
    </FormProvider>
  )
}

export default DonorInfo
